






















































import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { TYPES, BOOKING_PURPOSES } from "@/constants/booking"

@Component({
  computed: {
    ...mapState("Auth", {
      candidate: "candidate",
      user: "user"
    }),
    ...mapState("BookingCandidate", {
      bookingCandidate: "bookingCandidate"
    })
  }
})
export default class BookingCandidateReadDetails extends Vue {
  // candidate State
  candidate!: Model
  user!: Model
  // bookingCandidate State
  bookingCandidate!: BookingCandidate
  types = TYPES
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES
  bookingPurposes = BOOKING_PURPOSES
}
